import api from '@/services/api';

import { type PostCartProps } from '../types';

const BASE_URL = 'orders';

export const postOrder = async (payload: PostCartProps): Promise<PostCartProps> => await api.post(BASE_URL, payload);
